import { render, staticRenderFns } from "./refundTickets.vue?vue&type=template&id=20b1b09b&scoped=true"
import script from "./refundTickets.vue?vue&type=script&lang=js"
export * from "./refundTickets.vue?vue&type=script&lang=js"
import style0 from "./refundTickets.vue?vue&type=style&index=0&id=20b1b09b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b1b09b",
  null
  
)

export default component.exports